export const INIT_RANDOM_COLORS = 'INIT_RANDOM_COLORS'
export const INIT_RANDOM_COLORS_ERROR = 'INIT_RANDOM_COLORS_ERROR'
export const UPDATE_PENDING_COLORS = 'UPDATE_PENDING_COLORS'
export const TOGGLE_SINGLE_COLOR = 'TOGGLE_SINGLE_COLOR'
